import { caseInfo } from '@/mocks/gossipData';

export default function TimelineSection() {
  return (
    <section id="timeline" className="w-full scroll-mt-24 bg-background-100/70">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-10 md:px-6 md:py-14">
        <div className="flex items-center gap-2">
          <span className="h-1.5 w-1.5 rounded-full bg-primary-500" />
          <span className="text-xs font-bold tracking-widest text-primary-600 uppercase">当事人回应</span>
        </div>
        <h2 className="mt-1 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">本周深度追踪档案</h2>

        <div className="mt-6 overflow-hidden rounded-2xl border border-background-200 bg-background-50">
          <div className="flex flex-col lg:flex-row">
            <div className="relative lg:w-[46%]">
              <div className="h-56 w-full lg:h-full lg:min-h-[360px]">
                <img
                  src={caseInfo.cover}
                  alt="抖阴黑料 当事人回应专题时间线配图"
                  className="h-full w-full object-cover object-top"
                />
              </div>
              <span className="absolute left-4 top-4 inline-flex items-center gap-1.5 rounded-full bg-background-50/95 px-3 py-1 text-xs font-semibold text-primary-700">
                <i className="ri-flag-2-line" /> {caseInfo.tag}
              </span>
            </div>

            <div className="flex flex-1 flex-col p-5 md:p-7">
              <div className="flex flex-col gap-2">
                <h3 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">{caseInfo.title}</h3>
                <p className="text-sm leading-relaxed text-foreground-600">{caseInfo.lead}</p>
              </div>

              <div className="mt-5 flex flex-col gap-0">
                {caseInfo.timeline.map((s, idx) => (
                  <div key={s.time} className="relative flex gap-4 pb-5 last:pb-0">
                    {idx < caseInfo.timeline.length - 1 ? (
                      <span className="absolute left-[7px] top-4 h-full w-px bg-background-300" />
                    ) : null}
                    <span
                      className={`relative z-10 mt-1 flex h-4 w-4 shrink-0 items-center justify-center rounded-full border-2 ${
                        idx === caseInfo.timeline.length - 1
                          ? 'border-primary-500 bg-primary-500'
                          : 'border-accent-400 bg-background-50'
                      }`}
                    />
                    <div className="flex-1">
                      <div className="flex flex-wrap items-center gap-2">
                        <span className="text-xs font-semibold text-foreground-500">{s.time}</span>
                        <span
                          className={`rounded-full px-2 py-0.5 text-[11px] font-medium ${
                            s.tag === '自证'
                              ? 'bg-primary-100 text-primary-800'
                              : s.tag === '回应'
                                ? 'bg-accent-100 text-accent-900'
                                : 'bg-secondary-100 text-secondary-800'
                          }`}
                        >
                          {s.tag}
                        </span>
                      </div>
                      <p className="mt-1 text-sm leading-relaxed text-foreground-800">{s.text}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}